import { render, staticRenderFns } from "./integral_list_detail.vue?vue&type=template&id=53152777&scoped=true&"
import script from "./integral_list_detail.vue?vue&type=script&lang=js&"
export * from "./integral_list_detail.vue?vue&type=script&lang=js&"
import style0 from "./integral_list_detail.vue?vue&type=style&index=0&id=53152777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53152777",
  null
  
)

export default component.exports